import { PaymentMethod } from '../PartnerOrganizations/models';
import { CardStatus } from './models';
export var CARD_ASSIGN_STATUS_CONFIRMED = 'CONFIRMED';
export var CARD_ASSIGN_STATUS_FAILED = 'ASSIGN_CARD_FAILED';
/**
 * Decides whether a card-assign attempt should be reported as confirmed or
 * failed once fresh card-check data (from either the signup or org flow) is
 * available. Returns null when there is nothing to report yet, or the
 * card-assign flow has already reached a terminal state.
 *
 * `cardAssigned` gates this on the *current* assign attempt having actually
 * succeeded (it's reset to false on every CARD_ASSIGN_REQUEST). Without it,
 * this would fire using whatever card-check data is already sitting in redux
 * from an earlier page/session — e.g. a stale "no card on file" result from
 * before the user ever submitted the new card — and report a false failure
 * before the real assignment has even completed.
 *
 * `cardCheckLoading` closes a second, narrower race: `CARD_ASSIGN_SUCCESS`
 * (which flips `cardAssigned` to true) and the follow-up card-check request
 * it triggers (checkOrgStatusSummery / checkCustomerCardSignup) are two
 * separate dispatches — `cardAssigned` can turn true one render before the
 * follow-up request's *fresh* result arrives, while `cardPaymentMethod`
 * still holds the pre-attempt value. Requiring `!cardCheckLoading` too means
 * we wait for that follow-up request to actually finish before trusting its
 * data, instead of reading a stale value in the gap between the two.
 */
export var resolveCardAssignStatus = function (_a) {
    var paymentModalState = _a.paymentModalState, defaultPaymentMethod = _a.defaultPaymentMethod, cardPaymentMethod = _a.cardPaymentMethod, cardAssigned = _a.cardAssigned, cardCheckLoading = _a.cardCheckLoading;
    if (!cardAssigned || cardCheckLoading || !cardPaymentMethod)
        return null;
    if (paymentModalState === 'CALL_COMPLETE' ||
        paymentModalState === 'ASSIGN_CARD_FAILED') {
        return null;
    }
    if (defaultPaymentMethod === PaymentMethod.Card &&
        cardPaymentMethod.card_valid === CardStatus.Valid) {
        return CARD_ASSIGN_STATUS_CONFIRMED;
    }
    return CARD_ASSIGN_STATUS_FAILED;
};
/**
 * The signup flow checks card validity via `checkCustomerCardSignup`
 * (Root's paymentDetails.customerCard). The organization flow checks it via
 * `checkOrgStatusSummery` (orgStatusSummery's payment_summary.card_payment_method).
 * These land in different redux slices, so callers must pick the one that
 * matches the current `type`.
 */
export var selectCardCheckSource = function (type, signupCardPaymentMethod, orgCardPaymentMethod) {
    return type === 'SIGNUP' ? signupCardPaymentMethod : orgCardPaymentMethod;
};
/** Same signup-vs-org split as {@link selectCardCheckSource}, for the matching loading flag. */
export var selectCardCheckLoading = function (type, signupCardCheckLoading, orgCardCheckLoading) {
    return type === 'SIGNUP' ? signupCardCheckLoading : orgCardCheckLoading;
};
